import { Plugin, PluginKey } from 'prosemirror-state';
export const maxCharacterCountPluginKey = new PluginKey('maxCharacterCountPlugin');
export default class MaxCharacterCountPlugin extends Plugin {
  constructor(maxCharacters) {
    super({
      key: maxCharacterCountPluginKey,
      filterTransaction: (transaction, state) => {
        let limit = maxCharacters;

        // Nothing has changed or no limit is defined. Ignore it.
        if (!transaction.docChanged || limit === 0 || limit === null || limit === undefined) {
          return true;
        }
        let oldSize = getTextLength(state.doc);
        let newSize = getTextLength(transaction.doc);

        // Everything is in the limit. Good.
        if (newSize <= limit) {
          return true;
        }

        // The limit has already been exceeded but will be reduced.
        if (oldSize > limit && newSize > limit && newSize <= oldSize) {
          return true;
        }

        // The limit has already been exceeded and will be increased further.
        if (oldSize > limit && newSize > limit && newSize > oldSize) {
          return false;
        }
        let isPaste = transaction.getMeta('paste');

        // Block all exceeding transactions that were not pasted.
        if (!isPaste) {
          return false;
        }

        // For pasted content, we try to remove the exceeding content.
        let pos = transaction.selection.$head.pos;
        let over = newSize - limit;
        let from = pos - over;
        let to = pos;

        // It’s probably a bad idea to mutate transactions within `filterTransaction`
        // but for now this is working fine.
        transaction.deleteRange(from, to);

        // In some situations, the limit will continue to be exceeded after trimming.
        // This happens e.g. when truncating within a complex node (e.g. table)
        // and ProseMirror has to close this node again.
        // If this is the case, we prevent the transaction completely.
        let updatedSize = getTextLength(transaction.doc);
        if (updatedSize > limit) {
          return false;
        }
        return true;
      }
    });
  }
}
function getTextLength(doc) {
  let text = doc.textBetween(0, doc.content.size, '\n');
  return text.length + totalTemplateNodesTextLength(doc);
}

/**
 * Computes sum of the length of all template nodes in the document serialized to text.
 * @param doc - The document to compute the text length of.
 * @returns The total length
 */
function totalTemplateNodesTextLength(doc) {
  let length = 0;
  doc.descendants(node => {
    if (node.type.name === 'template') {
      length += templateNodeTextLength(node);
    }
    return true;
  });
  return length;
}
function templateNodeTextLength(node) {
  // We serialize a template node to text like this : {{attribute_path}}
  // When a fallback value is provided, we serialize like this:  {{attribute_path|fallback:\"fallback_value\"}}

  if (node.attrs.fallback && node.attrs.fallback.length > 0) {
    return `{{${node.attrs.attributePath}|fallback:\\"${node.attrs.fallback}\\"}}`.length;
  } else {
    return `{{${node.attrs.attributePath}}}`.length;
  }
}